module.exports = __webpack_public_path__ + "static/media/kid_avatar_07.1b9ea35e.png";